import React from "react";
import { useNavigate } from "react-router-dom";
import KpiCard from "./KpiCard.jsx";

const KPIGrid = ({ stats, error_report_stats }) => {
   const navigate = useNavigate();

   const handleCardClick = (filterParams) => {
      const params = new URLSearchParams();

      // Add filter parameters
      Object.entries(filterParams).forEach(([key, value]) => {
         if (value !== null && value !== undefined && value !== "") {
            params.set(key, value);
         }
      });

      // Navigate to forms page with filters
      navigate(`/forms?${params.toString()}`);
   };

   return (
      <div className="kpi-grid">
         <KpiCard
            value={stats?.total_submissions || 0}
            label="Total Submissions"
            icon="bi bi-file-earmark-text"
            color="primary"
            trend={`+${stats?.submissions_today || 0} today`}
            trendType="up"
            clickable={true}
            onClick={() => handleCardClick({})} // Show all forms
         />
         <KpiCard
            value={stats?.driver_verifications || 0}
            label="Driver Verifications"
            icon="bi bi-person-check"
            color="success"
            clickable={true}
            onClick={() => handleCardClick({ form_type: "driver_verification" })}
         />
         <KpiCard
            value={stats?.dispatch_forms || 0}
            label="Dispatch Forms"
            icon="bi bi-truck"
            color="info"
            clickable={true}
            onClick={() => handleCardClick({ form_type: "dispatch" })}
         />
         <KpiCard
            value={error_report_stats?.total_error_reports || 0}
            label="Error Reports"
            icon="bi bi-exclamation-triangle"
            color="danger"
            clickable={true}
            onClick={() => handleCardClick({ error_status: "with_errors" })}
         />
         <KpiCard
            value={error_report_stats?.unresolved_reports || 0}
            label="Unresolved"
            icon="bi bi-clock-history"
            color="warning"
            clickable={true}
            onClick={() => handleCardClick({ error_status: "with_errors" })} // Could add resolution filter if needed
         />
         <KpiCard
            value={error_report_stats?.resolved_reports || 0}
            label="Resolved"
            icon="bi bi-check-circle"
            color="success"
            clickable={true}
            onClick={() => handleCardClick({ error_status: "with_errors" })} // Could add resolution filter if needed
         />
      </div>
   );
};

export default KPIGrid;
